import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavMenuItem from './NavMenuItem';
import { roleMenuList } from 'Actions';

class HorizontalMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedMenuItem: null,
            activeMenu: null,
        };
    }

    componentDidMount() {
        this.props.roleMenuList();
    }

    handleMenuItemClick = (featureName) => {
        this.setState((prevState) => ({
            selectedMenuItem: prevState.selectedMenuItem === featureName ? null : featureName,
        }));
    };

    handleMouseEnter = (featureName) => {
        this.setState({ activeMenu: featureName });
    };

    handleMouseLeave = () => {
        this.setState({ activeMenu: null });
    };

    render() {
        const { menulist } = this.props;
        const { selectedMenuItem, activeMenu } = this.state;

        return (
            <div className="horizontal-menu">
                <ul className="list-unstyled nav">
                    {menulist.map((feature, key) => (
                        <li
                            className={`nav-item ${selectedMenuItem === feature.name ? 'selected' : ''}`}
                            key={key}
                            onMouseEnter={() => this.handleMouseEnter(feature.name)}
                            onMouseLeave={this.handleMouseLeave}
                        >
                            <a
                                
                                onClick={() => this.handleMenuItemClick(feature.name)}
                                className="nav-link"
                            >
                                <i className="zmdi zmdi-device-hub"></i>
                                <span className="menu-title">{feature.name}</span>
                            </a>
                            {activeMenu === feature.name && (
                                <ul className="list-unstyled sub-menu">
                                    {feature.menu.map((menu, index) => (
                                        <NavMenuItem menu={menu} key={index} />
                                    ))}
                                </ul>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}
const mapStateToProps = ({ mostlyused }) => {
    const { menulist } = mostlyused;
    return { menulist };
};

export default connect(mapStateToProps, {
    roleMenuList,
})(HorizontalMenu);
